import React from 'react';
import { useDashboard } from '../contexts/DashboardContext';
import MarketCard from '../components/MarketCard';
import { Search } from 'lucide-react';
import { Input } from '../components/ui/input';

const MarketDataSection = () => {
  const { marketData } = useDashboard();
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredData = marketData.filter(
    (asset) =>
      asset.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      asset.symbol.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-4xl font-bold text-slate-900 mb-2">Market Data</h2>
        <p className="text-slate-600">Real-time market prices and trends</p>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
        <Input
          data-testid="market-search-input"
          type="text"
          placeholder="Search markets..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredData.map((asset) => (
          <MarketCard
            key={asset.symbol}
            symbol={asset.symbol}
            name={asset.name}
            price={asset.price}
            changePercent={asset.change_percent}
            sparkline={asset.sparkline}
          />
        ))}
      </div>
    </div>
  );
};

export default MarketDataSection;